import React from "react";
import { logEvent } from "@Lib/analytics";

import styles from "./index.module.less";
import { g4 } from "../../../../utils/helper";

const _gaEvent = (action, label) => {
  logEvent("影音詳細頁", action, label);
};

class RecommendMovieList extends React.Component {
  io = null;

  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  componentDidMount() {
    this.scrollWatch(this.el);
  }

  scrollWatch = (el) => {
    let isFrist = false;
    const { data } = this.props;

    try {
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !isFrist) {
            isFrist = true;
            g4 &&
              g4("video_exposured", {
                page: "影音詳情頁",
                spm: "",
                channel: "影音",
                module: "列表",
                element: "欄目影音",
                element_id: "影音",
                object_type: "",
                object_id: data.id,
                sub_module: "",
                next_spm: "7.263.78.99",
              });
          }
        },
        { threshold: [0.65] },
      );
      if (el) {
        this.io.observe(el);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { data, index } = this.props;

    return (
      <a
        href={`/movies/${data.id}?currentIndex=${index + 1}&spm=${"7.263.78.99"}`}
        onClick={() => {
          _gaEvent("推薦影音", data.title),
            g4("video_clicked", {
              page: "影音詳情頁",
              spm: "",
              channel: "影音",
              module: "列表",
              element: "欄目影音",
              element_id: "影音",
              object_type: "",
              object_id: data.id,
              sub_module: "",
              next_spm: "7.263.78.99",
            });
        }}
        ref={(el) => (this.el = el)}
      >
        <div className={styles["item"]}>
          <div className={styles["play-gray-item"]}>
            <img className={styles["img"]} src={`${data.thumb}`} />
            <img className={styles["icon"]} src='https://photo.8891.com.tw/2023/08/15/1692090155275148.png' />
            <div className={styles["video-time"]}>{data.playTime}</div>
          </div>

          <h6 className={styles["no-seen"]}>{`${data.title}`}</h6>
        </div>
      </a>
    );
  }
}

export default RecommendMovieList;
